import classNames from "classnames";
import type { ReactNode } from "react";
import { DebugModeToggle } from "../../../components/DebugMode/DebugModeToggle.tsx";

export const MenuLayout = ({
  outerComponent,
  innerComponent,
  rightToLeft,
  className,
}: {
  outerComponent: ReactNode;
  innerComponent: ReactNode;
  rightToLeft?: boolean;
  className?: string;
}) => (
  <div
    className={classNames(
      rightToLeft ? "flex-row-reverse" : "flex-row",
      "h-full divide-x-025",
      className,
    )}
  >
    <div className="w-[72px] p-200">
      <div className="flex-col h-full justify-between gap-150">
        <div className="flex-fill">{outerComponent}</div>
        <DebugModeToggle />
      </div>
    </div>
    {innerComponent ? <div className="flex-fill">{innerComponent}</div> : null}
    <div className="border-l-025 border-primary-rest" />
  </div>
);
